// extracted by mini-css-extract-plugin
module.exports = {"footer":"ThirdPartyAdminActionsModal_footer_1ULzY","confirmBtn":"ThirdPartyAdminActionsModal_confirmBtn_1yZoI","modalHeader":"ThirdPartyAdminActionsModal_modalHeader_3NK8i"};